import { getMappingNotesTypeList } from "../../api/list";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// State interface definition
interface MappingNotesTypeListState {
  MappingNotesTypeList: any[];
  isLoading: boolean;
  error: string | null;
}

// Initial state setup
const initialState: MappingNotesTypeListState = {
  MappingNotesTypeList: [],
  isLoading: false,
  error: null,
};

// Async action to fetch error mapping note type list
export const FetchMappingNotesTypeList = createAsyncThunk(
  "MappingNotesTypeList/fetchMappingNotesTypeList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getMappingNotesTypeList(params);
      const state: any = getState();
      const previousMappingNotesTypeList = state.MappingNotesTypeList?.MappingNotesTypeList || []; 
      if ([1, undefined].includes(res?.result?.page)) {

        dispatch(getMappingNotesType(res?.result?.data || []));
      } else {

        dispatch(getMappingNotesType([
          ...previousMappingNotesTypeList, 
          ...(res?.result?.data || []), 
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching mapping notes type list');
    }
  }
);

// Slice to manage MappingNotesTypeList state
const MappingNotesTypeListSlice = createSlice({
  name: 'MappingNotesTypeList',
  initialState,
  reducers: {
    getMappingNotesType(state, action: PayloadAction<any[]>) {
      state.MappingNotesTypeList = action.payload;
    },
  }
});

export default MappingNotesTypeListSlice.reducer;
export const { getMappingNotesType } = MappingNotesTypeListSlice.actions;
